import { Component } from '@angular/core';

@Component({
  selector: 'app-data-export-success',
  templateUrl: './data-export-success.component.html',
  styleUrls: ['./data-export-success.component.css']
})
export class DataExportSuccessComponent {

}
